//@flow
import React from 'react';

import MDEditor from '@uiw/react-md-editor';
import {makeStyles} from '@material-ui/styles';

import type {ICommand, TextState, TextAreaTextApi} from '@uiw/react-md-editor';
import {Person} from '@material-ui/icons';
import {INTERPOLATION_SETTING_VARS} from '../../modules/crm-campaigns/constants';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  editorText: {
    display: 'flex',
    borderRadius: '8px',
    flexDirection: 'row-reverse',
    minHeight: '50px',
    height: '50px',

    '& .w-md-editor-toolbar': {
      height: 'unset !important',
      minHeight: '28px !important',
      margin: 0,
      marginTop: '1rem',
      borderBottom: 'none',
      flexDirection: 'row-reverse',
      gap: 0,

      '& ul': {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
      },
      '& ul li button': {
        height: '30px',
      },
      '& ul li button:hover': {
        background: 'none',
      },
      '& ul:first-of-type': {
        // display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        gap: '4px',
        height: '100%',
      },
      '& ul:first-of-type li, ul:first-of-type li button': {
        borderRadius: '4px',
        backgroundColor: colors.lightPurple,
        width: '30px',
        height: '30px',
        color: colors.purple,
      },
    },
    '& .w-md-editor-text': {
      display: 'flex',
      height: '100%',
    },
    '& .w-md-editor-text-input ': {
      fontFamily: '"Poppins", "Muli", sans-serif !important',
      fontSize: '14px !important',
      paddingTop: '10px',
      overflow: 'auto',
    },
    '& .w-md-editor-content': {
      height: 'inherit !important',
      flexGrow: 1,
    },
    '& .w-md-editor-content > div > div > div > pre > code': {
      fontFamily: '"Poppins", "Muli", sans-serif !important',
      fontSize: '14px !important',
    },
    '& .w-md-editor-content > div > div > div > pre > code > span .token': {
      color: 'unset !important',
    },
    '& .w-md-editor-content > div > div > div > pre > code > span .italic': {
      fontStyle: 'unset',
    },
  },
}));

type Props = {
  className?: string,
  text: string,
  placeholder?: string,
  leftCommands?: ICommand[],
  onChange: (str: string) => void,
  disabledCommands?: boolean,
  disabled?: boolean,
};

export default function VariableInput(props: Props) {
  const {
    className,
    text,
    onChange,
    placeholder,
    disabled,
    disabledCommands = false,
  } = props;

  const classes = useStyles();

  const commands: ICommand[] = [
    {
      name: INTERPOLATION_SETTING_VARS.CRM_CONTACT_NAME.label,
      enabled: true,
      keyCommand: INTERPOLATION_SETTING_VARS.CRM_CONTACT_NAME.name,
      buttonProps: {'aria-label': 'Agregar nombre del contacto'},
      icon: <Person fontSize="small" />,
      execute: (state: TextState, api: TextAreaTextApi) => {
        api.replaceSelection(
          `{{${INTERPOLATION_SETTING_VARS.CRM_CONTACT_NAME.key}}}`
        );
      },
    },
  ];

  return (
    <div className={className || undefined} data-color-mode="light">
      <MDEditor
        textareaProps={{
          disabled: disabled,
          placeholder: placeholder ? placeholder : '',
        }}
        preview="edit"
        visibleDragbar={false}
        className={classes.editorText}
        value={text}
        height={100}
        onKeyDown={e => {
          if (e.key === 'Tab' || e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        onChange={onChange}
        commands={!disabledCommands ? commands : []}
        extraCommands={[]}
      />
    </div>
  );
}
